import { IAppropriationOfProfit } from '@modeso/types__aumico-lib-annualreport-be';
import { ITranslatorVisitor } from '../ITranslatorVisitor.interface';

export class AppropriationOfProfit {
    constructor(public aop: IAppropriationOfProfit) {}
    public accept(visitor: ITranslatorVisitor) {
        visitor.visit(this);
    }
}
